import type { Location, LocationMapMode, LocationsHashState } from './types';

export const LOCATION_MAP_MODE_LABEL: Record<LocationMapMode, string> = {
  image: '画像マップ',
  building: 'ビル',
  folder: 'フォルダ',
  geo: '地理地図',
};

export function getLocationMapModeLabel(mapMode: Location['mapMode']): string {
  if (!mapMode) return '未設定';
  return LOCATION_MAP_MODE_LABEL[mapMode];
}

export function getLocationMapModeTagColor(mapMode: Location['mapMode']): string {
  if (mapMode === 'geo') return 'green';
  if (mapMode === 'building') return 'purple';
  if (mapMode === 'image') return 'blue';
  return 'default';
}

export const getAllLocations = (locations: Location[]): Location[] => {
  let result: Location[] = [];
  locations.forEach((location) => {
    // mapX, mapYをxCoordinate, yCoordinateとしても持たせる（互換性のため）
    const loc = {
      ...location,
      xCoordinate: location.mapX,
      yCoordinate: location.mapY,
    };
    result.push(loc);
    if (location.children) {
      result = result.concat(getAllLocations(location.children));
    }
  });
  return result;
};

export const parseLocationsHash = (hash: string): LocationsHashState => {
  const raw = hash.startsWith('#') ? hash.slice(1) : hash;
  const trimmed = raw.trim();
  if (!trimmed) {
    return { branchId: null, scopeLocationId: null, mapLocationsScopeMode: null };
  }

  // Backward compatible: "#<locationId>"
  if (!trimmed.includes('=') && !trimmed.includes('&')) {
    return { branchId: null, scopeLocationId: decodeURIComponent(trimmed), mapLocationsScopeMode: null };
  }

  const params = new URLSearchParams(trimmed);
  const branchId = params.get('branch') ?? params.get('b');
  const scopeLocationId = params.get('scope') ?? params.get('s') ?? params.get('location') ?? params.get('l');
  const modeRaw = params.get('mode') ?? params.get('m');
  const mapLocationsScopeMode =
    modeRaw === 'direct' || modeRaw === 'all' ? (modeRaw as 'direct' | 'all') : null;

  return {
    branchId: branchId ? decodeURIComponent(branchId) : null,
    scopeLocationId: scopeLocationId ? decodeURIComponent(scopeLocationId) : null,
    mapLocationsScopeMode,
  };
};

export const buildLocationsHash = (state: LocationsHashState): string => {
  const params = new URLSearchParams();
  if (state.branchId) params.set('branch', state.branchId);
  if (state.scopeLocationId) params.set('scope', state.scopeLocationId);
  if (state.mapLocationsScopeMode && state.mapLocationsScopeMode !== 'direct') {
    params.set('mode', state.mapLocationsScopeMode);
  }
  const next = params.toString();
  return next ? `#${next}` : '';
};
